import React from 'react';
import { Image } from 'lucide-react';

const BeforeAfterSection = () => {
  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-900">
            See the difference
          </h2>
          <p className="text-stone-500 mt-4 max-w-md mx-auto">
            The same Flickr photo, before and after AI-generated metadata
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Before */}
          <div>
            <span className="text-xs font-medium tracking-widest uppercase text-stone-400 mb-4 block">
              Before
            </span>
            <div className="bg-white rounded-lg p-6 border border-stone-200">
              <div className="bg-stone-100 rounded mb-4 max-w-xs mx-auto">
                <div className="aspect-[3/4] relative overflow-hidden rounded">
                  <img
                    src="/images/sf-cityscape-example.jpg"
                    alt="San Francisco cityscape"
                    className="absolute inset-0 w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="absolute inset-0 bg-stone-200 flex items-center justify-center" style={{ display: 'none' }}>
                    <Image className="h-12 w-12 text-stone-400" />
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <div>
                  <div className="text-xs text-stone-400 mb-1">Title</div>
                  <div className="text-sm text-stone-400 italic">IMG_20240315_142637.jpg</div>
                </div>
                <div>
                  <div className="text-xs text-stone-400 mb-1">Description</div>
                  <div className="text-sm text-stone-400 italic">No description</div>
                </div>
                <div>
                  <div className="text-xs text-stone-400 mb-1">Tags</div>
                  <div className="text-sm text-stone-400 italic">No tags</div>
                </div>
              </div>
            </div>
          </div>

          {/* After */}
          <div>
            <span className="text-xs font-medium tracking-widest uppercase text-stone-400 mb-4 block">
              After
            </span>
            <div className="bg-white rounded-lg p-6 border border-amber-200">
              <div className="bg-stone-100 rounded mb-4 max-w-xs mx-auto">
                <div className="aspect-[3/4] relative overflow-hidden rounded">
                  <img
                    src="/images/sf-cityscape-example.jpg"
                    alt="San Francisco cityscape"
                    className="absolute inset-0 w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="absolute inset-0 bg-stone-200 flex items-center justify-center" style={{ display: 'none' }}>
                    <Image className="h-12 w-12 text-stone-400" />
                  </div>
                </div>
              </div>

              <div className="space-y-3">
                <div>
                  <div className="text-xs text-stone-400 mb-1">Title</div>
                  <div className="text-sm font-medium text-stone-900">San Francisco Skyline View from Fire Escape with Dramatic Clouds</div>
                </div>
                <div>
                  <div className="text-xs text-stone-400 mb-1">Description</div>
                  <div className="text-sm text-stone-600">
                    A striking urban landscape captured from a building's fire escape, showcasing San Francisco's iconic skyline with the Transamerica Pyramid prominently featured.
                  </div>
                </div>
                <div>
                  <div className="text-xs text-stone-400 mb-1">Tags</div>
                  <div className="flex flex-wrap gap-1">
                    {['san-francisco', 'cityscape', 'skyline', 'transamerica-pyramid', 'fire-escape', 'urban-photography', 'dramatic-clouds', 'california'].map(tag => (
                      <span key={tag} className="bg-amber-50 text-amber-700 text-xs px-2 py-0.5 rounded">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
